/**
 * @description
 */
export default function required(value) {
    return !!value && value.length > 7 || 'Minimo 8 caracteres.'
}
